// removed by extract-text-webpack-plugin
module.exports = {"AutoMessage":"AutoMessage__y7jW8","AutoMessageText":"AutoMessageText__3abZ7","CloseButton":"CloseButton__kij2H"};


//////////////////
// WEBPACK FOOTER
// ./components/style.scss
// module id = xs7b
// module chunks = 0